/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * RapidWorks.UserManagement.WebApi | v1
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type { FeatureListDto, ProblemDetails, UpdateFeatureSensitivityInput } from '../model';

import { axiosInstance } from '../../axios-instance.ts';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key]
    });
  }
  return result;
};

export const getApiUserManagementV1Features = (options?: SecondParameter<typeof axiosInstance>, signal?: AbortSignal) => {
  return axiosInstance<FeatureListDto>({ url: `/api/user-management/v1/features`, method: 'GET', signal }, options);
};

export const getGetApiUserManagementV1FeaturesQueryKey = () => {
  return [`/api/user-management/v1/features`] as const;
};

export const getGetApiUserManagementV1FeaturesQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiUserManagementV1Features>>,
  TError = unknown
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1Features>>, TError, TData>>;
  request?: SecondParameter<typeof axiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiUserManagementV1FeaturesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiUserManagementV1Features>>> = ({ signal }) =>
    getApiUserManagementV1Features(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiUserManagementV1Features>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiUserManagementV1FeaturesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiUserManagementV1Features>>>;
export type GetApiUserManagementV1FeaturesQueryError = unknown;

export function useGetApiUserManagementV1Features<TData = Awaited<ReturnType<typeof getApiUserManagementV1Features>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1Features>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1Features>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1Features>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1Features<TData = Awaited<ReturnType<typeof getApiUserManagementV1Features>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1Features>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiUserManagementV1Features>>,
          TError,
          Awaited<ReturnType<typeof getApiUserManagementV1Features>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiUserManagementV1Features<TData = Awaited<ReturnType<typeof getApiUserManagementV1Features>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1Features>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetApiUserManagementV1Features<TData = Awaited<ReturnType<typeof getApiUserManagementV1Features>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiUserManagementV1Features>>, TError, TData>>;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiUserManagementV1FeaturesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export const putApiUserManagementV1FeaturesSensitivity = (
  updateFeatureSensitivityInput: UpdateFeatureSensitivityInput,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<FeatureListDto>(
    {
      url: `/api/user-management/v1/features/sensitivity`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateFeatureSensitivityInput,
      signal
    },
    options
  );
};

export const getPutApiUserManagementV1FeaturesSensitivityMutationOptions = <TError = ProblemDetails, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiUserManagementV1FeaturesSensitivity>>,
    TError,
    { data: UpdateFeatureSensitivityInput },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiUserManagementV1FeaturesSensitivity>>,
  TError,
  { data: UpdateFeatureSensitivityInput },
  TContext
> => {
  const mutationKey = ['putApiUserManagementV1FeaturesSensitivity'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiUserManagementV1FeaturesSensitivity>>,
    { data: UpdateFeatureSensitivityInput }
  > = (props) => {
    const { data } = props ?? {};

    return putApiUserManagementV1FeaturesSensitivity(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiUserManagementV1FeaturesSensitivityMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiUserManagementV1FeaturesSensitivity>>
>;
export type PutApiUserManagementV1FeaturesSensitivityMutationBody = UpdateFeatureSensitivityInput;
export type PutApiUserManagementV1FeaturesSensitivityMutationError = ProblemDetails;

export const usePutApiUserManagementV1FeaturesSensitivity = <TError = ProblemDetails, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiUserManagementV1FeaturesSensitivity>>,
      TError,
      { data: UpdateFeatureSensitivityInput },
      TContext
    >;
    request?: SecondParameter<typeof axiosInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiUserManagementV1FeaturesSensitivity>>,
  TError,
  { data: UpdateFeatureSensitivityInput },
  TContext
> => {
  return useMutation(getPutApiUserManagementV1FeaturesSensitivityMutationOptions(options), queryClient);
};
